import { createApp } from 'vue'
import PopCoupon from '../pop_coupon';
import MyI18n from '../plugins/my_i18n'
//import { createApp } from 'vue';
const app = createApp(PopCoupon);
app.config.devtools = true
app.config.productionTip = false
app.use(MyI18n)
app.mount('#popcoupon')
  /* eslint-disable no-new */
document.addEventListener('DOMContentLoaded', () => {
  app.mount('#popcoupon')
});

/*
const app = createApp(
  {
    props: ['signURL'],
  },
  { signURL: 'Evan' }
  )
createApp(Pop).mount("#pop");
*/
